import { AegisClient } from '@nike/aegis-auth-react';
import { setGlobalHeader } from "../utils/http";

const aegisConfig = {
    qa: process.env.REACT_APP_CLOUD_DEV_PHASE !== 'prod', // whether we hit the test Okta or prod
    clientId: 'nike.l7r.bartender',
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT
};

const aegisClient = new AegisClient(aegisConfig);

function handleLogin({accessToken}) {
    setGlobalHeader('Authorization', 'Bearer ' + accessToken.accessToken)
}

aegisClient.on('login:success', handleLogin)
aegisClient.on('renew:access:success', handleLogin)


export default aegisClient;
